import { PermissionsApi } from 'api/PermissionsApi';
import { backendApiClient } from 'container/backendApiClient';

export const permissionsApi = new PermissionsApi(backendApiClient);
